import { render, staticRenderFns } from "./OverPrice.vue?vue&type=template&id=47b804fc&scoped=true&"
import script from "./OverPrice.vue?vue&type=script&lang=js&"
export * from "./OverPrice.vue?vue&type=script&lang=js&"
import style1 from "./OverPrice.vue?vue&type=style&index=1&id=47b804fc&lang=scss&scoped=true&"
import style2 from "./OverPrice.vue?vue&type=style&index=2&id=47b804fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b804fc",
  null
  
)

export default component.exports